module.exports = __webpack_public_path__ + "static/myPortrait2-020108faf2c81831a0b6e2ce1413cca3.jpeg";